import styled from "styled-components";

const Component = styled.div``;

export default function CarouselMove() {
  return <Component></Component>;
}
